import { render, staticRenderFns } from "./contactsPage.vue?vue&type=template&id=05c2b1a9&"
import script from "./contactsPage.vue?vue&type=script&lang=js&"
export * from "./contactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports